{
  "de": {
    "overview": {
      "actions": {
        "select_decision": "Entscheidung auswählen",
        "select_installment": "Rate auswählen",
        "select_point_list": "Punkteliste auswählen",
        "select_survey": "Umfrage auswählen"
      },
      "table": {
        "labels": {
          "category": "Kategorie",
          "level": "Ebene",
          "project": "Projekt",
          "status": "Status",
          "unit": "Einheit"
        }
      }
    }
  }
}
